import { Message } from "@/reducers/messagesSlice"
import { useMessageContext } from "@/components/ui/message/message"

function useMessage({
  forwarded,
  reply,
}: {
  forwarded?: boolean
  reply?: boolean
}): Message {
  const { message: originalMessage, replyMessage } = useMessageContext()
  return forwarded && originalMessage.forwarded
    ? originalMessage.forwarded
    : reply && replyMessage
      ? replyMessage
      : originalMessage
}

export default useMessage
